
import React from 'react';
import { useRevenueDataModel } from './hooks/useRevenueDataModel';
import { LeaderboardItem } from './types';
import { AttributionDimension } from './data-model';

interface RevenueDashboardProps {
  leaderboardData: LeaderboardItem[];
}

const RevenueDashboard: React.FC<RevenueDashboardProps> = ({ leaderboardData }) => {
  const { 
    dataModel, 
    isInitialized, 
    validationErrors, 
    hasErrors 
  } = useRevenueDataModel(leaderboardData);
  
  if (!isInitialized || !dataModel) {
    return null; // Don't render anything until initialized
  }
  
  // Get revenue breakdowns
  const revenueByRegion = dataModel.getRevenueByAttribution(AttributionDimension.GEOGRAPHY);
  const revenueByAccount = dataModel.getRevenueByAttribution(AttributionDimension.ACCOUNT);
  const revenueByProduct = dataModel.getRevenueByAttribution(AttributionDimension.PRODUCT);
  const totalRevenue = dataModel.getTotalRevenue();
  
  // Get count of accounts, products, and geographies
  const accountCount = dataModel.getAccounts().length;
  const productCount = dataModel.getProducts().length;
  const geoCount = dataModel.getGeographies().length;
  
  return (
    <div className="mt-4 text-white text-xs">
      <div className="text-slate-500 mb-2">
        Data model initialized with {accountCount} accounts, {productCount} products, 
        {geoCount} geographies, and {dataModel.getTransactions().length} transactions.
      </div>
      
      {hasErrors && (
        <div className="text-amber-400 mb-2">
          Found {validationErrors.length} data quality issues. Check console for details.
        </div>
      )}
      
      {/* This component doesn't directly display on UI but is available for the application
          to use when needed for applying business rules and logic */}
    </div>
  );
};

export default RevenueDashboard;
